var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        id: "create-vehicle-generic",
        "hide-header": "",
        centered: "",
        size: "modal",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        "ok-variant": "primary"
      },
      on: { ok: _vm.handleOk },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            var hide = ref.hide
            return [
              _c(
                "div",
                { staticClass: "w-100 d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100 mr-2",
                      attrs: { variant: "secondary" },
                      on: { click: _vm.hideModal }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [_vm._v(_vm._s(_vm.$t("Cancel")))]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100",
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.handleOk($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("annonce.online.button.Submit"))
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "div",
        [
          _c("h1", { staticClass: "page-title mb-4" }, [
            _vm._v(_vm._s(_vm.$t(_vm.titleModal)))
          ]),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              staticClass: "small-text",
              attrs: {
                label: _vm.$t(_vm.labelInput),
                invalidFeedback: _vm.baseVehicle.invalidFeedback,
                state: _vm.baseVehicle.state,
                "label-for": "name-input"
              }
            },
            [
              _c("b-form-input", {
                attrs: { id: "licensePlate-input" },
                model: {
                  value: _vm.baseVehicle.name,
                  callback: function($$v) {
                    _vm.$set(_vm.baseVehicle, "name", $$v)
                  },
                  expression: "baseVehicle.name"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c14dcf7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c14dcf7e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/annonce/AnnonceCreateVehicleGenericModal.vue
// module id = uYiR
// module chunks = 0